import { types } from 'mobx-state-tree';

import { getEntryConditions } from '../flows/get-entry-conditions';
import { loadable } from '../../mobx-utils';

const PassolutionContentBlock = types.model({
  headline: types.string,
  content: types.string,
});

const Error = types.model('ErrorResponse', {
  error: types.model({
    code: types.number,
    message: types.string,
  }),
  requestid: types.maybe(types.string),
});

const Conditions = types.model('EntryConditions', {
  headline: types.string,
  entry: PassolutionContentBlock,
  visa: PassolutionContentBlock,
  transitvisa: PassolutionContentBlock,
  inoculation: PassolutionContentBlock,
});

export const EntryConditions = loadable(
  types.array(types.union(Conditions, Error)),
  getEntryConditions,
);
